import { PlainInput2 } from 'components/PlainInput/PlainInput2'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import { Checkbox, Modal, PlainTable } from 'stories/components'

import { defaultInputs } from './constants'

interface AIAutoFillFieldModalProps {
  formData: Record<string, any>
  onClose: (acceptedValues: Record<string, any> | null) => void
}

export const AIAutoFillFieldModal = ({ formData, onClose }: AIAutoFillFieldModalProps) => {
  const [values, setValues] = useState<Record<string, any>>(() => ({ ...formData }))
  const [accepted, setAccepted] = useState<Record<string, boolean>>(() => {
    const initial: Record<string, boolean> = {}
    Object.entries(formData).forEach(([key, val]) => {
      initial[key] = val !== null && val !== undefined
    })
    return initial
  })

  useEffect(() => {
    if (formData.success === false && formData.message) {
      toast(formData.message, { type: 'warning' })
      onClose(null)
    }
  }, [formData])

  const handleSubmit = () => {
    const result: Record<string, any> = {}
    Object.entries(values).forEach(([key, val]) => {
      if (accepted[key]) result[key] = val
    })
    onClose(result)
  }

  const tableHeader = ['No', 'Field', 'Value', 'Accept']

  const inputs = defaultInputs()
  const tableData =
    formData.success !== false
      ? Object.entries(formData).map(([key], index) => [
          index + 1,
          <span className="font-medium text-gray-700">{inputs[key]?.title}</span>,
          <PlainInput2
            type="text"
            value={values[key] !== null && values[key] !== undefined ? String(values[key]) : ''}
            content={values[key] !== null && values[key] !== undefined ? String(values[key]) : '—'}
            onChange={(newVal: string) => setValues((prev) => ({ ...prev, [key]: newVal }))}
          />,
          <Checkbox
            id={`accept-${key}`}
            title=""
            value={accepted[key]}
            onChange={(checked) => setAccepted((prev) => ({ ...prev, [key]: checked }))}
          />,
        ])
      : []

  return (
    <Modal
      title="Auto fill fields from Appraisal Report"
      titleOkay="Submit"
      isOpen
      lastUpdatedAt={Date.now()}
      onClose={() => onClose(null)}
      onOk={handleSubmit}
    >
      <div className="w-full max-w-[720px] overflow-x-auto">
        <PlainTable header={tableHeader} data={tableData} tdClass="px-4 py-2" />
      </div>
    </Modal>
  )
}
